<div class="modal-container">
  <button
    id="modalSeleccionElemento"
    #modalSeleccionElemento
    data-bs-toggle="modal"
    data-bs-target="#modalElemento"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalElemento"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">
            Seleccione un elemento
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form
            [formGroup]="domFormGroup"
            (ngSubmit)="onSubmitSeleccionarElemento()">
            <div class="row">
              <div
                *ngFor="let field of fieldsElementos"
                class="col-md-{{ field.width }}">
                <label [for]="field.name" class="form-label"
                  >{{ field.label
                  }}<span
                    *ngIf="field.required"
                    _ngcontent-ng-c3465959523=""
                    class="text-danger">
                    *</span
                  ></label
                >
                <select
                  *ngIf="field.type === 'select'"
                  [id]="field.name"
                  class="form-select"
                  [formControlName]="field.name">
                  <option *ngFor="let option of elementos" [value]="option.Id">
                    {{ option.Nombre }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mt-3 d-flex gap-2">
              <button type="submit" class="btn-govco fill-btn-govco">
                Guardar
              </button>
              <button
                type="button"
                class="btn-govco btn-govco"
                data-bs-dismiss="modal">
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
